const SportsSchools = () => import('@/views/SportsSchools.vue')
const SportsSchoolsCreate = () => import('@/views/SportsSchoolsCreate.vue')
const SportsSchoolsEdit = () => import('@/views/SportsSchoolsEdit.vue')
const SportsFederations = () => import('@/views/SportsFederations.vue')
const SportsClubs = () => import('@/views/SportsClubs.vue')
const SportsFederationsCreate = () => import('@/views/SportsFederationsCreate.vue')
const SportsClubsCreate = () => import('@/views/SportsClubsCreate.vue')
const SportsFederationsEdit = () => import('@/views/SportsFederationsEdit.vue')
const SportsClubsEdit = () => import('@/views/SportsClubsEdit.vue')
const Faqs = () => import('@/views/Faqs.vue')
const FaqEdit = () => import('@/views/FaqEdit.vue')
const FaqCreate = () => import('@/views/FaqCreate.vue')
const FaqPermission = () => import('@/views/FaqPermission.vue')
const SportsClubsAthletes = () => import( '@/views/SportsClubsAthletes.vue')

export const routes = [
  {
    path: '/sports-schools',
    name: 'sportsSchools',
    component: SportsSchools,
    redirect: '/sports-schools/new',
    meta: {auth: true},
    children: [
      {
        path: '/sports-schools/new',
        name: 'sportsSchoolNew',
        component: SportsSchoolsCreate,
        meta: {auth: true},
      },
      {
        path: '/sports-schools/:id/edit',
        name: 'sportsSchoolEdit',
        component: SportsSchoolsEdit,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/sports-federations',
    name: 'sportsFederations',
    component: SportsFederations,
    redirect: '/sports-federations/new',
    meta: {auth: true},
    children: [
      {
        path: '/sports-federations/new',
        name: 'sportsFederationNew',
        component: SportsFederationsCreate,
        meta: {auth: true},
      },
      {
        path: '/sports-federations/:id/edit',
        name: 'sportsFederationEdit',
        component: SportsFederationsEdit,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/sports-clubs',
    name: 'sportsClubs',
    component: SportsClubs,
    redirect: '/sports-clubs/new',
    meta: {auth: true},
    children: [
      {
        path: '/sports-clubs/new',
        name: 'sportsClubCreate',
        component: SportsClubsCreate,
        meta: {auth: true},
      },
      {
        path: '/sports-clubs/:id/edit',
        name: 'sportsClubEdit',
        component: SportsClubsEdit,
        meta: {auth: true},
      },
      {
        path: '/sports-clubs/:id/athletes',
        name: 'sportsClubsAthletes',
        component: SportsClubsAthletes,
        meta: {auth: true},
      },
    ],
  },
  {
    path: '/faq',
    name: 'faq',
    component: Faqs,
    redirect: '/faq/new',
    meta: {auth: true},
    children: [
      {
        path: '/faq/new',
        name: 'faqNew',
        component: FaqCreate,
      },
      {
        path: '/faq/:id/edit',
        name: 'faqEdit',
        component: FaqEdit,
      },
      {
        path: '/faq/:id/result',
        name: 'FaqPermission',
        component: FaqPermission,
      },
    ],
  },
]
